// ACTIONS

export const LOG_ROCKET_SESSION_URL = 'LOG_ROCKET_SESSION_URL';

export const INITIALIZE_COMPLETE = 'INITIALIZE_COMPLETE';
export const INITIALIZE_RESET = 'INITIALIZE_RESET';
export const SET_METRICS_MASTER = 'SET_METRICS_MASTER';
export const SET_DIMENSIONS_MASTER = 'SET_DIMENSIONS_MASTER';
export const SET_MASTER_DATA = 'SET_MASTER_DATA';
export const SET_USER_AGREEMENT = 'SET_USER_AGREEMENT';
export const SET_UI_THEME = 'SET_UI_THEME';
export const SET_AUTHORIZATION_CONFIG = 'SET_AUTHORIZATION_CONFIG';
export const SET_SECTIONS_TO_SHOW = 'SET_SECTIONS_TO_SHOW';
export const RESET_PREFILL_DATA = 'RESET_PREFILL_DATA';
export const UPDATE_FINANCING_CTA_VISIBILITY_STATUS = 'UPDATE_FINANCING_CTA_VISIBILITY_STATUS';

// For play
export const PLAY_SET_FIELD_VALUE = 'PLAY_SET_FIELD_VALUE';
export const PLAY_UPDATE_CHART_NAME = 'PLAY_UPDATE_CHART_NAME';
export const PLAY_SET_DEFAULT = 'PLAY_SET_DEFAULT';
export const PLAY_SET_DATA = 'PLAY_SET_DATA';
export const PLAY_SET_CHART_DATA_LOADING = 'PLAY_SET_CHART_DATA_LOADING';
export const PLAY_SET_CHART_DATA_SUCCESS = 'PLAY_SET_CHART_DATA_SUCCESS';
export const PLAY_SET_CHART_DATA_ERROR = 'PLAY_SET_CHART_DATA_ERROR';
export const PLAY_SHOW_ERRORS = 'PLAY_SHOW_ERRORS';
export const PLAY_SAVE_PLAY_DATA_LOADING = 'PLAY_SAVE_PLAY_DATA_LOADING';
export const PLAY_SAVE_PLAY_DATA_SUCCESS = 'PLAY_SAVE_PLAY_DATA_SUCCESS';
export const PLAY_SAVE_PLAY_DATA_ERROR = 'PLAY_SAVE_PLAY_DATA_ERROR';
export const PLAY_REFRESH_DATA = 'PLAY_REFRESH_DATA';
export const DISABLE_SAVING = 'DISABLE_SAVING';

// For dashboard
export const DASHBOARD_SET_CURRENT = 'DASHBOARD_SET_CURRENT_ID';
export const DASHBOARD_SET_LAYOUT = 'DASHBOARD_SET_LAYOUT';
export const DASHBOARD_SET_NAME = 'DASHBOARD_SET_NAME';
export const DASHBOARD_START_EDIT = 'DASHBOARD_START_EDIT';
export const DASHBOARD_DISCARD_EDIT = 'DASHBOARD_DISCARD_EDIT';
export const DASHBOARD_SAVE_EDIT = 'DASHBOARD_SAVE_EDIT';
export const DASHBOARD_EDIT_LOADING = 'DASHBOARD_EDIT_LOADING';
export const DASHBOARD_SET_DATA_LOADED = 'DASHBOARD_SET_DATA_LOADED';
export const DASHBOARD_START_DATA_LOADING = 'DASHBOARD_START_DATA_LOADING';
export const DASHBOARD_START_CARD_DATA_LOADING = 'DASHBOARD_START_CARD_DATA_LOADING';
export const DASHBOARD_SET_CARD_DATA_LOADED = 'DASHBOARD_SET_CARD_DATA_LOADED';
export const DASHBOARD_SET_CARD_DATA_ERROR = 'DASHBOARD_SET_CARD_DATA_ERROR';
export const DASHBOARD_RESET_STATE = 'DASHBOARD_RESET_STATE';
export const DASHBOARD_PRESENT_TOGGLE = 'DASHBOARD_PRESENT_TOGGLE';
export const DASHBOARD_REMOVE_CARD = 'DASHBOARD_REMOVE_CARD';

// For User Management
export const USER_SET_USERS = 'USER_SET_USERS';
export const USER_APPLY_FILTER = 'USER_APPLY_FILTER';

// For navigation
export const TOGGLE_SIDE_MENU = 'TOGGLE_SIDE_MENU';
export const OPEN_SIDE_MENU = 'OPEN_SIDE_MENU';
export const CLOSE_SIDE_MENU = 'CLOSE_SIDE_MENU';

// Maintain list of dashboards
export const ADD_NEW_DASHBOARD = 'ADD_NEW_DASHBOARD';
export const DELETE_DASHBOARD = 'DELETE_DASHBOARD';
export const UPDATE_ALL_DASHBOARD = 'UPDATE_ALL_DASHBOARD';
export const SET_STAR_FOR_DASHBOARD = 'SET_STAR_FOR_DASHBOARD';
export const SET_STAR_FOR_DASHBOARD_SELECTED = 'SET_STAR_FOR_DASHBOARD_SELECTED';

export const UPDATE_ALL_EXCEPTION_RULES = 'UPDATE_ALL_EXCEPTION_RULES';
export const EXCEPTION_RULES_LIST = 'EXCEPTION_RULES_LIST';
export const EXCEPTION_RULES_LIST_LOADING = 'EXCEPTION_RULES_LIST_LOADING';
export const SET_EXCEPTION_ALERT_INSTANCES = 'SET_EXCEPTION_ALERT_INSTANCES';
export const EXCEPTION_ALERT_INSTANCES_LOADING = 'EXCEPTION_ALERT_INSTANCES_LOADING';

export const EXCEPTION_ALERT_DEFINITION_LIST = 'EXCEPTION_ALERT_DEFINITION_LIST';
export const EXCEPTION_ALERT_DEFINITION_LIST_LOADING = 'EXCEPTION_ALERT_DEFINITION_LIST_LOADING';

// container tracking

export const CONTAINER_DETAILS_FILTER_APPLIED = 'CONTAINER_DETAILS_FILTER_APPLIED';
export const CONTAINER_DETAILS_LOADING = 'CONTAINER_DETAILS_LOADING';
export const CONTAINER_DETAILS_SET_DATA = 'CONTAINER_DETAILS_SET_DATA';
export const CONTAINER_DETAILS_ERROR = 'CONTAINER_DETAILS_ERROR';
export const CONTAINER_DETAILS_SUBCONTAINER_SELECTED = 'CONTAINER_DETAILS_SUBCONTAINER_SELECTED';
export const CONTAINER_DETAILS_TABLE_LOADING = 'CONTAINER_DETAILS_TABLE_LOADING';

export const SET_FORCE_LOGOUT = 'SET_FORCE_LOGOUT';
export const SET_LOGOUT = 'SET_LOGOUT';
export const SET_PASSWORD_EXPIRED = 'SET_PASSWORD_EXPIRED';
export const CLEAR_PASSWORD_EXPIRED = 'CLEAR_PASSWORD_EXPIRED';

export const PERMISSIONS_UPDATE_DATA = 'PERMISSIONS_UPDATE_DATA';
export const PERMISSIONS_ENABLE_LOADING = 'PERMISSIONS_ENABLE_LOADING';
export const PERMISSIONS_DISABLE_LOADING = 'PERMISSIONS_DISABLE_LOADING';
export const PERMISSIONS_PAGINATION = 'PERMISSIONS_PAGINATION';
export const PERMISSIONS_RESET_PAGINATION = 'PERMISSIONS_RESET_PAGINATION';
export const PERMISSIONS_UPDATE_FILTER = 'PERMISSIONS_UPDATE_FILTER';
export const PERMISSIONS_RESET_FILTER = 'PERMISSIONS_RESET_FILTER';

// multiple container tracking
export const IMPORTS_UPDATE_DATA = 'IMPORTS_UPDATE_DATA';
export const IMPORTS_ENABLE_LOADING = 'IMPORTS_ENABLE_LOADING';
export const IMPORTS_DISABLE_LOADING = 'IMPORTS_DISABLE_LOADING';
export const IMPORTS_UPDATE_FILTER = 'IMPORTS_UPDATE_FILTER';
export const IMPORTS_UPDATE_SELECTED_SHIPMENTS = 'IMPORTS_UPDATE_SELECTED_SHIPMENTS';
export const IMPORTS_RESET_FILTER = 'IMPORTS_RESET_FILTER';
export const IMPORTS_PAGINATION = 'IMPORTS_PAGINATION';
export const IMPORTS_RESET_PAGINATION = 'IMPORTS_RESET_PAGINATION';
export const SET_IMPORTS_MASTER = 'SET_IMPORTS_MASTER';

export const EXPORTS_UPDATE_DATA = 'EXPORTS_UPDATE_DATA';
export const EXPORTS_ENABLE_LOADING = 'EXPORTS_ENABLE_LOADING';
export const EXPORTS_DISABLE_LOADING = 'EXPORTS_DISABLE_LOADING';
export const EXPORTS_UPDATE_FILTER = 'EXPORTS_UPDATE_FILTER';
export const EXPORTS_RESET_FILTER = 'EXPORTS_RESET_FILTER';
export const EXPORTS_PAGINATION = 'EXPORTS_PAGINATION';
export const EXPORTS_RESET_PAGINATION = 'EXPORTS_RESET_PAGINATION';

// rfq
export const RFQ_FETCH_ENABLE_LOADING = 'RFQ_FETCH_ENABLE_LOADING';
export const RFQ_FETCH_DISABLE_LOADING = 'RFQ_FETCH_DISABLE_LOADING';
export const RFQ_FETCH_LOADED = 'RFQ_FETCH_LOADED';
export const RFQ_FETCH_ERROR = 'RFQ_FETCH_ERROR';
export const RFQ_SET_PAGINATION = 'RFQ_SET_PAGINATION';
export const RFQ_UPDATE_FILTERS = 'RFQ_UPDATE_FILTERS';
export const RFQ_RESET_FILTERS = 'RFQ_RESET_FILTERS';
export const RFQ_RESET_PAGINATION = 'RFQ_RESET_PAGINATION';
export const RFQ_CREATE_ENABLE_LOADING = 'RFQ_CREATE_ENABLE_LOADING';
export const RFQ_CREATE_DISABLE_LOADING = 'RFQ_CREATE_DISABLE_LOADING';
export const RFQ_DETAILS_ENABLE_LOADING = 'RFQ_DETAILS_ENABLE_LOADING';
export const RFQ_DETAILS_DISABLE_LOADING = 'RFQ_DETAILS_DISABLE_LOADING';
export const RFQ_DETAILS_LOADED = 'RFQ_DETAILS_LOADED';
export const RFQ_DETAILS_ERROR = 'RFQ_DETAILS_ERROR';
export const RFQ_EDIT_REFERENCE_RATE_ENABLE_LOADING = 'RFQ_EDIT_REFERENCE_RATE_ENABLE_LOADING';
export const RFQ_EDIT_REFERENCE_RATE_DISABLE_LOADING = 'RFQ_EDIT_REFERENCE_RATE_DISABLE_LOADING';
export const RFQ_EDIT_STATUS_ENABLE_LOADING = 'RFQ_EDIT_STATUS_ENABLE_LOADING';
export const RFQ_EDIT_STATUS_DISABLE_LOADING = 'RFQ_EDIT_STATUS_DISABLE_LOADING';
export const RFQ_SEND_ENABLE_LOADING = 'RFQ_SEND_ENABLE_LOADING';
export const RFQ_SEND_DISABLE_LOADING = 'RFQ_SEND_DISABLE_LOADING';
export const RFQ_DETAIL_BID_ENABLE_LOADING = 'RFQ_DETAIL_BID_ENABLE_LOADING';
export const RFQ_DETAIL_BID_DISABLE_LOADING = 'RFQ_DETAIL_BID_DISABLE_LOADING';
export const RFQ_DETAIL_BID_DATA = 'RFQ_DETAIL_BID_DATA';
export const RFQ_DETAIL_BID_ERROR = 'RFQ_DETAIL_BID_ERROR';
export const RFQ_SET_PERMISSABLE_PORTS = 'RFQ_SET_PERMISSABLE_PORTS';
export const RFQ_SET_DESTINATION_PORTS = 'RFQ_SET_DESTINATION_PORTS';
export const RFQ_SELECT_BID_LINE_ITEM_ENABLE_LOADING = 'RFQ_SELECT_BID_LINE_ITEM_ENABLE_LOADING';
export const RFQ_SELECT_BID_LINE_ITEM_DISABLE_LOADING = 'RFQ_SELECT_BID_LINE_ITEM_DISABLE_LOADING';
export const RFQ_BID_DETAILS_ENABLE_LOADING = 'RFQ_BID_DETAILS_ENABLE_LOADING';
export const RFQ_BID_DETAILS_DISABLE_LOADING = 'RFQ_BID_DETAILS_DISABLE_LOADING';
export const RFQ_BID_DETAILS_LOADED = 'RFQ_BID_DETAILS_LOADED';
export const RFQ_BID_DETAILS_ERROR = 'RFQ_BID_DETAILS_ERROR';
export const RFQ_UPDATE_STATUS_ENABLE_LOADING = 'RFQ_UPDATE_STATUS_ENABLE_LOADING';
export const RFQ_UPDATE_STATUS_DISABLE_LOADING = 'RFQ_UPDATE_STATUS_DISABLE_LOADING';
export const RFQ_BID_COMPARISON_ENABLE_LOADING = 'RFQ_BID_COMPARISON_ENABLE_LOADING';
export const RFQ_BID_COMPARISON_DISABLE_LOADING = 'RFQ_BID_COMPARISON_DISABLE_LOADING';
export const RFQ_BID_COMPARISON_LOADED = 'RFQ_BID_COMPARISON_LOADED';
export const REPLACE_PREV_PAGINATION = 'REPLACE_PREV_PAGINATION';
export const RFQ_RESET_BID_LIST_FILTERS = 'RFQ_RESET_BID_LIST_FILTERS';
export const RFQ_BID_RESET_BID_DATA = 'RFQ_BID_RESET_BID_DATA';

// rfq details pagination
export const DETAILS_SET_PAGINATION = 'DETAILS_SET_PAGINATION';
export const DETAILS_RESET_PAGINATION = 'DETAILS_RESET_PAGINATION';

// bid items pagination
export const BID_ITEMS_SET_PAGINATION = 'BID_ITEMS_SET_PAGINATION';
export const BID_ITEMS_RESET_PAGINATION = 'BID_ITEMS_RESET_PAGINATION';

// sales order
export const SO_UPDATE_DATA = 'SO_UPDATE_DATA';
export const SO_ENABLE_LOADING = 'SO_ENABLE_LOADING';
export const SO_DISABLE_LOADING = 'SO_DISABLE_LOADING';
export const SO_UPDATE_FILTER = 'SO_UPDATE_FILTER';
export const SO_RESET_FILTER = 'SO_RESET_FILTER';
export const SO_PAGINATION = 'SO_PAGINATION';
export const SO_RESET_PAGINATION = 'SO_RESET_PAGINATION';
export const SO_SET_MORE_FILTER = 'SO_SET_MORE_FILTER';
export const SO_APPLY_MORE_FILTER = 'SO_APPLY_MORE_FILTER';
export const SO_CANCEL_MORE_FILTER = 'SO_CANCEL_MORE_FILTER';
export const RFQ_DETAIL_UPDATE_FILTER = 'RFQ_DETAIL_UPDATE_FILTER';
export const SET_EXIM_TYPE = 'SET_EXIM_TYPE';

// bidding details
export const BIDDING_DETAILS_ENABLE_LOADING = 'BIDDING_DETAILS_ENABLE_LOADING';
export const BIDDING_DETAILS_DISABLE_LOADING = 'BIDDING_DETAILS_DISABLE_LOADING';
export const BIDDING_DETAILS_LOADED = 'BIDDING_DETAILS_LOADED';
export const BIDDING_DETAILS_ERROR = 'BIDDING_DETAILS_ERROR';
export const BIDDING_RESET_FILTER = 'BIDDING_RESET_FILTER';
export const BIDDING_SET_ORIGIN_PORTS = 'BIDDING_SET_ORIGIN_PORTS';
export const ADD_BID_ENABLE_LOADING = 'ADD_BID_ENABLE_LOADING';
export const ADD_BIDS_MORE_ENABLE_LOADING = 'ADD_BIDS_MORE_ENABLE_LOADING';
export const ADD_BIDS_MORE_DISABLE_LOADING = 'ADD_BIDS_MORE_DISABLE_LOADING';
export const ADD_BID_DISABLE_LOADING = 'ADD_BID_DISABLE_LOADING';
export const BIDDING_SEND_ENABLE_LOADING = 'BIDDING_SEND_ENABLE_LOADING';
export const BIDDING_SEND_DISABLE_LOADING = 'BIDDING_SEND_DISABLE_LOADING';

export const BIDDING_FETCH_ENABLE_LOADING = 'BIDDING_FETCH_ENABLE_LOADING';
export const BIDDING_FETCH_DISABLE_LOADING = 'BIDDING_FETCH_DISABLE_LOADING';
export const BIDDING_FETCH_LOADED = 'BIDDING_FETCH_LOADED';
export const BIDDING_FETCH_ERROR = 'BIDDING_FETCH_ERROR';
export const BIDDING_RESET_FILTERS = 'BIDDING_RESET_FILTERS';
export const BIDDING_SET_PAGINATION = 'BIDDING_SET_PAGINATION';
export const BIDDING_RESET_PAGINATION = 'BIDDING_RESET_PAGINATION';
export const BIDDING_UPDATE_FILTERS = 'BIDDING_UPDATE_FILTERS';
export const BIDDING_DETAIL_RESET_FILTER = 'BIDDING_RESET_FILTER';
export const BIDDING_ACTIVITY_ENABLE_LOADING = 'BIDDING_ACTIVITY_ENABLE_LOADING';
export const BIDDING_ACTIVITY_DISABLE_LOADING = 'BIDDING_ACTIVITY_DISABLE_LOADING';
export const BIDDING_ACTIVITY_LOADED = 'BIDDING_ACTIVITY_LOADED';

export const LAST_QUOTE_ENABLE_LOADING = 'LAST_QUOTE_ENABLE_LOADING';
export const LAST_QUOTE_DISABLE_LOADING = 'LAST_QUOTE_DISABLE_LOADING';
export const LAST_QUOTE_LOADED = 'LAST_QUOTE_LOADED';
export const RESET_LAST_QUOTE_DATA = 'RESET_LAST_QUOTE_DATA';

export const SAVED_QUOTE_ENABLE_LOADING = 'SAVED_QUOTE_ENABLE_LOADING';
export const SAVED_QUOTE_DISABLE_LOADING = 'SAVED_QUOTE_DISABLE_LOADING';
export const SAVED_QUOTE_LOADED = 'SAVED_QUOTE_LOADED';
export const RESET_SAVED_QUOTE_DATA = 'RESET_SAVED_QUOTE_DATA';
export const ORIGIN_PORTS_ENABLE_LOADING = 'ORIGIN_PORTS_ENABLE_LOADING';
export const ORIGIN_PORTS_DISABLE_LOADING = 'ORIGIN_PORTS_DISABLE_LOADING';
export const BIDDING_DETAILS_UPDATE_FILTERS = 'BIDDING_DETAILS_UPDATE_FILTERS';
export const RFQ_PERMISSABLE_PORTS_ENABLE_LOADING = 'RFQ_PERMISSABLE_PORTS_ENABLE_LOADING';
export const RFQ_PERMISSABLE_PORTS_DISABLE_LOADING = 'RFQ_PERMISSABLE_PORTS_DISABLE_LOADING';
export const RFQ_DESTINATION_PORTS_ENABLE_LOADING = 'RFQ_DESTINATION_PORTS_ENABLE_LOADING';
export const RFQ_DESTINATION_PORTS_DISABLE_LOADING = 'RFQ_DESTINATION_PORTS_DISABLE_LOADING';
export const RFQ_LINE_ITEM_ACTIVITY_ENABLE_LOADING = 'RFQ_LINE_ITEM_ACTIVITY_ENABLE_LOADING';
export const RFQ_LINE_ITEM_ACTIVITY_DISABLE_LOADING = 'RFQ_LINE_ITEM_ACTIVITY_DISABLE_LOADING';
export const RFQ_LINE_ITEM_ACTIVITY_LOADED = 'RFQ_LINE_ITEM_ACTIVITY_LOADED';
export const ALL_BIDDING_DETAILS_LOADED = 'ALL_BIDDING_DETAILS_LOADED';
export const RFQ_BID_ACTIVITY_ENABLE_LOADING = 'RFQ_BID_ACTIVITY_ENABLE_LOADING';
export const RFQ_BID_ACTIVITY_DISABLE_LOADING = 'RFQ_BID_ACTIVITY_DISABLE_LOADING';
export const RFQ_BID_ACTIVITY_LOADED = 'RFQ_BID_ACTIVITY_LOADED';
export const RFQ_DETAILS_ALL_DATA_LOADED = 'RFQ_DETAILS_ALL_DATA_LOADED';
export const RFQ_FINALISE_BID_ENABLE_LOADING = 'RFQ_FINALISE_BID_ENABLE_LOADING';
export const RFQ_FINALISE_BID_DISABLE_LOADING = 'RFQ_FINALISE_BID_DISABLE_LOADING';
export const RFQ_BID_LIST_UPDATE_FILTER = 'RFQ_BID_LIST_UPDATE_FILTER';
export const RFQ_BID_DOWNLOAD_ENABLE_LOADING = 'RFQ_BID_DOWNLOAD_ENABLE_LOADING';
export const RFQ_BID_DOWNLOAD_DISABLE_LOADING = 'RFQ_BID_DOWNLOAD_DISABLE_LOADING';
export const RFQ_BID_DOWNLOADED = 'RFQ_BID_DOWNLOADED';
export const RFQ_ADD_LINE_ITEM_ENABLE_LOADING = 'RFQ_ADD_LINE_ITEM_ENABLE_LOADING';
export const RFQ_ADD_LINE_ITEM_DISABLE_LOADING = 'RFQ_ADD_LINE_ITEM_DISABLE_LOADING';
export const FILTER_FINALISE_BID_ENABLE_LOADING = 'FILTER_FINALISE_BID_ENABLE_LOADING';
export const FILTER_FINALISE_BID_DISABLE_LOADING = 'FILTER_FINALISE_BID_DISABLE_LOADING';
export const EDIT_REFERENCE_RATE_BULK_ENABLE_LOADING = 'EDIT_REFERENCE_RATE_BULK_ENABLE_LOADING';
export const EDIT_REFERENCE_RATE_BULK_DISABLE_LOADING = 'EDIT_REFERENCE_RATE_BULK_DISABLE_LOADING';
export const MASTER_DATA_FETCH_ERROR = 'MASTER_DATA_FETCH_ERROR';

// summary dashboard
export const META_DATA_LOADED = 'META_DATA_LOADED';
export const STATUS_COUNTS_LOADED = 'STATUS_COUNTS_LOADED';
export const SUMMARY_DASHBOARD_SET_FILTER = 'SUMMARY_DASHBOARD_SET_FILTER';
export const SUMMARY_DASHBOARD_SET_PAGINATION = 'SUMMARY_DASHBOARD_SET_PAGINATION';
export const SUMMARY_DASHBOARD_RESET_PAGINATION = 'SUMMARY_DASHBOARD_RESET_PAGINATION';
export const SUMMARY_DASHBOARD_PREV_PAGINATION = 'SUMMARY_DASHBOARD_PREV_PAGINATION';
export const SUMMARY_DASHBOARD_UPDATE_DATA = 'SUMMARY_DASHBOARD_UPDATE_DATA';
export const SUMMARY_DASHBOARD_SET_TABLE_DATA = 'SUMMARY_DASHBOARD_SET_TABLE_DATA';
export const SUMMARY_DASHBOARD_SET_TABLE_COLUMNS = 'SUMMARY_DASHBOARD_SET_TABLE_COLUMNS';
export const SUMMARY_DASHBOARD_ENABLE_LOADING = 'SUMMARY_DASHBOARD_ENABLE_LOADING';
export const SUMMARY_DASHBOARD_DISABLE_LOADING = 'SUMMARY_DASHBOARD_DISABLE_LOADING';

// Get all Bids for an Inquiry
export const INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_SET_FILTERS =
  'INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_SET_FILTERS';
export const INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_APPLY_FILTERS =
  'INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_APPLY_FILTERS';
export const INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_SET_PAGINATION =
  'INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_SET_PAGINATION';
export const INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_RESET_FILTERS =
  'INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_RESET_FILTERS';
export const INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_RESET_PAGINATION =
  'INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_RESET_PAGINATION';
export const INQUIRY_SHIPPER_GET_ALL_BIDS_INQUIRY = 'INQUIRY_SHIPPER_GET_ALL_BIDS_INQUIRY';
export const INQUIRY_SHIPPER_GET_ALL_BIDS_DATA_ENABLE_LOADING =
  'INQUIRY_SHIPPER_GET_ALL_BIDS_DATA_ENABLE_LOADING';
export const INQUIRY_SHIPPER_GET_ALL_BIDS_INQUIRY_FETCH_ERROR =
  'INQUIRY_SHIPPER_GET_ALL_BIDS_INQUIRY_FETCH_ERROR';
export const INQUIRY_SHIPPER_GET_ALL_BIDS_DATA_DISABLE_LOADING =
  'INQUIRY_SHIPPER_GET_ALL_BIDS_DATA_DISABLE_LOADING';

// Search an Inquiry
export const INQUIRY_SHIPPER_SEARCH_ENABLE_LOADING = 'INQUIRY_SHIPPER_SEARCH_ENABLE_LOADING';
export const INQUIRY_SHIPPER_SEARCH_DISABLE_LOADING = 'INQUIRY_SHIPPER_SEARCH_DISABLE_LOADING';
export const INQUIRY_SHIPPER_SEARCH_SET_DATA = 'INQUIRY_SHIPPER_SEARCH_SET_DATA';
export const INQUIRY_SHIPPER_SEARCH_ERROR = 'INQUIRY_SHIPPER_SEARCH_ERROR';

// Get all Inquiries
export const INQUIRY_SHIPPER_GET_ALL_INQUIRIES = 'INQUIRY_SHIPPER_GET_ALL_INQUIRIES';
export const INQUIRY_SHIPPER_GET_STATUS_WISE_COUNT = 'INQUIRY_SHIPPER_GET_STATUS_WISE_COUNT';
export const INQUIRY_SHIPPER_GET_ALL_INQUIRIES_FETCH_ERROR =
  'INQUIRY_SHIPPER_GET_ALL_INQUIRIES_FETCH_ERROR';
export const INQUIRY_SHIPPER_GET_ALL_INQUIRIES_ENABLE_LOADING =
  'INQUIRY_SHIPPER_GET_ALL_INQUIRIES_ENABLE_LOADING';
export const INQUIRY_SHIPPER_GET_ALL_INQUIRIES_DISABLE_LOADING =
  'INQUIRY_SHIPPER_GET_ALL_INQUIRIES_DISABLE_LOADING';
export const INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_FILTERS =
  'INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_FILTERS';
export const INQUIRY_SHIPPER_GET_ALL_INQUIRIES_APPLY_FILTERS =
  'INQUIRY_SHIPPER_GET_ALL_INQUIRIES_APPLY_FILTERS';
export const INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_PAGINATION =
  'INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_PAGINATION';
export const INQUIRY_SHIPPER_GET_ALL_INQUIRIES_RESET_FILTERS =
  'INQUIRY_SHIPPER_GET_ALL_INQUIRIES_RESET_FILTERS';
export const INQUIRY_SHIPPER_GET_ALL_INQUIRIES_RESET_PAGINATION =
  'INQUIRY_SHIPPER_GET_ALL_INQUIRIES_RESET_PAGINATION';
export const INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_PREV_PAGINATION =
  'INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_PREV_PAGINATION';
export const INQUIRY_SHIPPER_BIDS_RANKING_DATA = 'INQUIRY_SHIPPER_BIDS_RANKING_DATA';
export const INQUIRY_SHIPPER_BIDS_RANKING_DATA_IS_LOADING = 'INQUIRY_SHIPPER_BIDS_RANKING_DATA_IS_LOADING';
export const INQUIRY_SHIPPER_BOOKING_STAT_COUNTS_DATA = 'INQUIRY_SHIPPER_BOOKING_STAT_COUNTS_DATA';
export const INQUIRY_SHIPPER_BOOKING_STAT_COUNTS_DATA_IS_LOADING = 'INQUIRY_SHIPPER_BOOKING_STAT_COUNTS_DATA_IS_LOADING';


// Get Inquiry Detail
export const INQUIRY_FF_DETAILS = 'INQUIRY_FF_DETAILS';
export const INQUIRY_DETAIL_FETCH_ERROR = 'INQUIRY_DETAIL_FETCH_ERROR';
export const INQUIRY_SHIPPER_GET_INQUIRY_DETAIL_ENABLE_LOADING =
  'INQUIRY_SHIPPER_GET_INQUIRY_DETAIL_ENABLE_LOADING';
export const INQUIRY_SHIPPER_GET_INQUIRY_DETAIL_DISABLE_LOADING =
  'INQUIRY_SHIPPER_GET_INQUIRY_DETAIL_DISABLE_LOADING';
export const INQUIRY_SHIPPER_INQUIRY_DETAIL_FETCH_ERROR =
  'INQUIRY_SHIPPER_INQUIRY_DETAIL_FETCH_ERROR';
export const INQUIRY_SHIPPER_SET_INQUIRY_DETAIL_DATA = 'INQUIRY_SHIPPER_SET_INQUIRY_DETAIL_DATA';
export const INQUIRY_SHIPPER_SET_INQUIRY_ID_FOR_DETAIL =
  'INQUIRY_SHIPPER_SET_INQUIRY_ID_FOR_DETAIL';
export const SET_CREATE_INQUIRY_DATA = 'SET_CREATE_INQUIRY_DATA';

// BULK INQUIRY ACTIONS
export const BULK_INQUIRY_CHECK_CHANGED = 'BULK_INQUIRY_CHECK_CHANGED';
// INQUIRY_FF bids
export const INQUIRY_FF_BOOKING_STAT_COUNTS_DATA = 'INQUIRY_FF_BOOKING_STAT_COUNTS_DATA';
export const INQUIRY_FF_BOOKING_STAT_COUNTS_DATA_IS_LOADING = 'INQUIRY_FF_BOOKING_STAT_COUNTS_DATA_IS_LOADING';
export const INQUIRY_FF_BIDS_RANKING_DATA = 'INQUIRY_FF_BIDS_RANKING_DATA';
export const INQUIRY_FF_BIDS_RANKING_DATA_IS_LOADING = 'INQUIRY_FF_BIDS_RANKING_DATA_IS_LOADING';
export const INQUIRY_FF_UPDATE_DATA = 'INQUIRY_FF_UPDATE_DATA';
export const INQUIRY_FF_GET_STATUS_WISE_COUNT = 'INQUIRY_FF_GET_STATUS_WISE_COUNT';
export const INQUIRY_FF_SET_BID_MASTER_DATA = 'INQUIRY_FF_SET_BID_MASTER_DATA';
export const INQUIRY_FF_SET_BID_MASTER_LOAD_ERROR = 'INQUIRY_FF_SET_BID_MASTER_LOAD_ERROR';
export const INQUIRY_FF_SET_RECENT_BIDS = 'INQUIRY_FF_SET_RECENT_BIDS';
export const INQUIRY_FF_RECENT_BID_LOAD_ERROR = 'INQUIRY_FF_RECENT_BID_LOAD_ERROR';
export const INQUIRY_FF_SET_RECENT_BID_PAGINATION = 'INQUIRY_FF_SET_RECENT_BID_PAGINATION';
export const INQUIRY_FF_ENABLE_LOADING = 'INQUIRY_FF_ENABLE_LOADING';
export const INQUIRY_FF_DISABLE_LOADING = 'INQUIRY_FF_DISABLE_LOADING';
export const INQUIRY_FF_SET_FILTER = 'INQUIRY_FF_SET_FILTER';
export const INQUIRY_FF_APPLY_FILTER = 'INQUIRY_FF_APPLY_FILTER';
export const INQUIRY_FF_APPLY_SORT = 'INQUIRY_FF_APPLY_SORT';
export const INQUIRY_FF_RESET_FILTER = 'INQUIRY_FF_RESET_FILTER';
export const INQUIRY_FF_PAGINATION = 'INQUIRY_FF_PAGINATION';
export const INQUIRY_FF_RESET_PAGINATION = 'INQUIRY_FF_RESET_PAGINATION';
export const INQUIRY_FF_SET_PREV_PAGINATION = 'INQUIRY_FF_SET_PREV_PAGINATION';
export const INQUIRY_FF_FETCH_ERROR = 'INQUIRY_FF_FETCH_ERROR';
export const INQUIRY_FF_BIDS_SET_FILTER = 'INQUIRY_FF_BIDS_SET_FILTER';
export const INQUIRY_FF_BIDS_APPLY_FILTER = 'INQUIRY_FF_BIDS_APPLY_FILTER';
export const INQUIRY_FF_BIDS_RESET_FILTERS = 'INQUIRY_FF_BIDS_RESET_FILTERS';
export const INQUIRY_FF_BIDS_ENABLE_LOADING = 'INQUIRY_FF_BIDS_ENABLE_LOADING';
export const INQUIRY_FF_BIDS_DISABLE_LOADING = 'INQUIRY_FF_BIDS_DISABLE_LOADING';
export const INQUIRY_FF_BIDS_GET_ALL_BIDS = 'INQUIRY_FF_BIDS_GET_ALL_BIDS';
export const INQUIRY_FF_BIDS_GET_ALL_BIDS_FETCH_ERROR = 'INQUIRY_FF_BIDS_GET_ALL_BIDS_FETCH_ERROR';
export const INQUIRY_FF_VIEW_BREAKDOWN = 'INQUIRY_FF_VIEW_BREAKDOWN';
export const INQUIRY_DELETE_INQUIRY = 'INQUIRY_DELETE_INQUIRY';
export const SEND_INQUIRY_FOR_FF = 'SEND_INQUIRY_FOR_FF';
export const INQUIRY_FF_SET_INQUIRY_DETAIL_DATA = 'INQUIRY_FF_SET_INQUIRY_DETAIL_DATA';
export const INQUIRY_FF_INQUIRY_DETAIL_LOAD_ERROR = 'INQUIRY_FF_INQUIRY_DETAIL_LOAD_ERROR';
export const INQUIRY_FF_CREATE_BID_SET_CHARGES = 'INQUIRY_FF_CREATE_BID_SET_CHARGES';
export const INQUIRY_FF_BID_CHARGES_LOADING = 'INQUIRY_FF_BID_CHARGES_LOADING';
export const INQUIRY_FF_CREATE_BID_PAGE_FORM = 'INQUIRY_FF_CREATE_BID_PAGE_FORM';
export const INQUIRY_FF_ADD_NEW_CHARGE = 'INQUIRY_FF_ADD_NEW_CHARGE';
export const INQUIRY_FF_SET_UPDATE_CHARGE_ENTITIES = 'INQUIRY_FF_SET_UPDATE_CHARGE_ENTITIES';
export const INQUIRY_FF_RECENT_BID_LOADING = 'INQUIRY_FF_RECENT_BID_LOADING';
export const INQUIRY_FF_DELETE_CHARGE = 'INQUIRY_FF_DELETE_CHARGE';
export const INQUIRY_FF_BID_SET_INIT_CHARGE_DETAILS = 'INQUIRY_FF_BID_SET_INIT_CHARGE_DETAILS';
export const INQUIRY_FF_ADD_RESET_DATA = 'INQUIRY_FF_ADD_RESET_DATA';
export const INQUIRY_FF_SET_PORTS = 'INQUIRY_FF_SET_PORTS';
export const INQUIRY_SET_LINKED_FFS_FOR_INQUIRY = 'INQUIRY_SET_LINKED_FFS_FOR_INQUIRY';

// INQUIRY MASTERDATA
export const INQUIRY_MASTER_DATA = 'INQUIRY_MASTER_DATA';
export const UPDATE_INTTRA_CODE_IN_INQUIRY_MASTER_DATA = 'UPDATE_INTTRA_CODE_IN_INQUIRY_MASTER_DATA';

// For Masters
export const MASTERS_SET_PAGINATION = 'MASTERS_SET_PAGINATION';
export const MASTERS_RESET_PAGINATION = 'MASTERS_RESET_PAGINATION';
export const MASTERS_NEXT_PAGINATION = 'MASTERS_NEXT_PAGINATION';
export const MASTERS_SET_PER_PAGE = 'MASTERS_SET_PER_PAGE';
// BOOKING INQUIRY
export const BOOKING_INQUIRY_UPDATE_DATA = 'BOOKING_INQUIRY_UPDATE_DATA';
export const BOOKING_INQUIRY_SET_BID_MASTER_DATA = 'BOOKING_INQUIRY_SET_BID_MASTER_DATA';
export const BOOKING_INQUIRY_SET_BID_MASTER_LOAD_ERROR =
  'BOOKING_INQUIRY_SET_BID_MASTER_LOAD_ERROR';
export const BOOKING_INQUIRY_SET_RECENT_BIDS = 'BOOKING_INQUIRY_SET_RECENT_BIDS';
export const BOOKING_INQUIRY_RECENT_BID_LOAD_ERROR = 'BOOKING_INQUIRY_RECENT_BID_LOAD_ERROR';
export const BOOKING_INQUIRY_SET_RECENT_BID_PAGINATION =
  'BOOKING_INQUIRY_SET_RECENT_BID_PAGINATION';
export const BOOKING_INQUIRY_ENABLE_LOADING = 'BOOKING_INQUIRY_ENABLE_LOADING';
export const BOOKING_INQUIRY_DISABLE_LOADING = 'BOOKING_INQUIRY_DISABLE_LOADING';
export const BOOKING_INQUIRY_SET_FILTER = 'BOOKING_INQUIRY_SET_FILTER';
export const BOOKING_INQUIRY_CANCEL_FILTER = 'BOOKING_INQUIRY_CANCEL_FILTER';
export const BOOKING_INQUIRY_GET_STATUS_WISE_COUNT = 'BOOKING_INQUIRY_GET_STATUS_WISE_COUNT';
export const BOOKING_INQUIRY_APPLY_FILTER = 'BOOKING_INQUIRY_APPLY_FILTER';
export const BOOKING_INQUIRY_APPLY_SORT = 'BOOKING_INQUIRY_APPLY_SORT';
export const BOOKING_INQUIRY_RESET_FILTER = 'BOOKING_INQUIRY_RESET_FILTER';
export const BOOKING_INQUIRY_PAGINATION = 'BOOKING_INQUIRY_PAGINATION';
export const BOOKING_INQUIRY_RESET_PAGINATION = 'BOOKING_INQUIRY_RESET_PAGINATION';
export const BOOKING_INQUIRY_SET_PREV_PAGINATION = 'BOOKING_INQUIRY_SET_PREV_PAGINATION';
// SHIPMENT EXECUTION
export const SHIPMENT_EXECUTION_SET_FILTER = 'SHIPMENT_EXECUTION_SET_FILTER';
export const SHIPMENT_EXECUTION_RESET_FILTER = 'SHIPMENT_EXECUTION_RESET_FILTER';
export const SHIPMENT_EXECUTION_RESET_MORE_FILTER = 'SHIPMENT_EXECUTION_RESET_MORE_FILTER';
export const SHIPMENT_EXECUTION_PAGINATION = 'SHIPMENT_EXECUTION_PAGINATION';
export const SHIPMENT_EXECUTION_ENABLE_LOADING = 'SHIPMENT_EXECUTION_ENABLE_LOADING';
export const SHIPMENT_EXECUTION_DISABLE_LOADING = 'SHIPMENT_EXECUTION_DISABLE_LOADING';
export const SHIPMENT_EXECUTION_UPDATE_DATA = 'SHIPMENT_EXECUTION_UPDATE_DATA';
export const SHIPMENT_EXECUTION_APPLY_FILTER = 'SHIPMENT_EXECUTION_APPLY_FILTER';
export const SHIPMENT_EXECUTION_CANCEL_FILTER = 'SHIPMENT_EXECUTION_CANCEL_FILTER';
export const SHIPMENT_EXECUTION_SET_PREV_PAGINATION = 'SHIPMENT_EXECUTION_SET_PREV_PAGINATION';
export const SHIPMENT_EXECUTION_RESET_PAGINATION = 'SHIPMENT_EXECUTION_RESET_PAGINATION';
export const SHIPMENT_EXECUTION_FETCH_CONTAINERS_DATA = 'SHIPMENT_EXECUTION_FETCH_CONTAINERS_DATA';
export const SHIPMENT_CONTAINER_FETCHING_DATA = 'SHIPMENT_CONTAINER_FETCHING_DATA';
export const SHIPMENT_EXECUTION_SET_SHIPMENT_INSTRUCTIONS = 'SHIPMENT_EXECUTION_SET_SHIPMENT_INSTRUCTIONS';
export const SHIPMENT_EXECUTION_SET_SI_LOADING = 'SHIPMENT_EXECUTION_SET_SI_LOADING';
export const SHIPMENT_EXECUTION_SET_SI_PENDING_COUNT = 'SHIPMENT_EXECUTION_SET_SI_PENDING_COUNT';
export const SHIPMENT_EXECUTION_SET_SI_DETAILS = 'SHIPMENT_EXECUTION_SET_SI_DETAILS';
export const SHIPMENT_EXECUTION_MILESTONE_COUNT = 'SHIPMENT_EXECUTION_MILESTONE_COUNT';
export const SHIPMENT_EXECUTION_TOGGLE_WATCH = 'SHIPMENT_EXECUTION_TOGGLE_WATCH';
export const SHIPMENT_EXECUTION_IS_SI_PENDING_COUNT_LOADING = 'SHIPMENT_EXECUTION_IS_SI_PENDING_COUNT_LOADING';
export const SHIPMENT_EXECUTION_SET_VGM_REQUESTS = 'SHIPMENT_EXECUTION_SET_VGM_REQUESTS';
export const SHIPMENT_EXECUTION_SET_VGM_DETAILS = 'SHIPMENT_EXECUTION_SET_VGM_DETAILS';
export const SHIPMENT_EXECUTION_SET_VESSEL_MASTER = 'SHIPMENT_EXECUTION_SET_VESSEL_MASTER';
export const SHIPMENT_EXECUTION_SET_FORM13_REQUESTS = 'SHIPMENT_EXECUTION_SET_FORM13_REQUESTS';
export const SHIPMENT_EXECUTION_SET_FORM13_DETAILS = 'SHIPMENT_EXECUTION_SET_FORM13_DETAILS';
export const SHIPMENT_EXECUTION_DROPDOWN_MASTERDATA = 'SHIPMENT_EXECUTION_DROPDOWN_MASTERDATA';
export const SHIPMENT_EXECUTION_ENABLE_LOAD_TRACKING = 'SHIPMENT_EXECUTION_ENABLE_LOAD_TRACKING';
export const SHIPMENT_EXECUTION_DISABLE_LOAD_TRACKING = 'SHIPMENT_EXECUTION_DISABLE_LOAD_TRACKING';
export const SHIPMENT_EXECUTION_UPDATE_CARD_AT_INDEX = 'SHIPMENT_EXECUTION_UPDATE_CARD_AT_INDEX';
export const SHIPMENT_EXECUTION_SET_SELECTED_SHIPMENTS = 'SHIPMENT_EXECUTION_SET_SELECTED_SHIPMENTS';

// Organisation Profile
export const ORG_PROFILE_SET_PROFILE_DATA = 'ORG_PROFILE_SET_PROFILE_DATA';
export const ORG_PROFILE_SET_ORG_MASTER = 'ORG_PROFILE_SET_ORG_MASTER';
export const ORG_PROFILE_SET_ORG_DETAILS = 'ORG_PROFILE_SET_ORG_DETAILS';
export const ORG_PROFILE_LOADING = 'ORG_PROFILE_LOADING';

// Activity Master Data
export const ACTIVITY_MASTER_DATA = 'ACTIVITY_MASTER_DATA';
export const IS_FETCHING_ACTIVITY_MASTER_DATA = 'IS_FETCHING_ACTIVITY_MASTER_DATA';
export const ACTIVITY_MASTER_ERROR_MESSAGE = 'ACTIVITY_MASTER_ERROR_MESSAGE';

// Invoice
export const INVOICE_SET_FILTERS = 'INVOICE_SET_FILTER';
export const INVOICE_RESET_FILTERS = 'INVOICE_RESET_FILTERS';
export const INVOICE_SET_PAGINATION = 'INVOICE_SET_PAGINATION';
export const INVOICE_RESET_PAGINATION = 'INVOICE_RESET_PAGINATION';
export const INVOICE_RESET_FILTER_PAGINATION = 'INVOICE_RESET_FILTER_PAGINATION';
export const INVOICE_MASTER_DATA = 'INVOICE_MASTER_DATA';
export const INVOICE_SET_SEARCH_RESULTS = 'INVOICE_SET_SEARCH_RESULTS';
export const INVOICE_SET_SEARCHING = 'INVOICE_SET_SEARCHING';
export const INVOICE_SET_LOADING = 'INVOICE_SET_LOADING';
export const INVOICE_SET_INVOICE_DATA = 'INVOICE_SET_INVOICE_DATA';
export const INVOICE_ACTIVITY_SET_FILTER = 'INVOICE_ACTIVITY_SET_FILTER';
export const INVOICE_ACTIVITY_SET_DATA = 'INVOICE_ACTIVITY_SET_DATA';
export const INVOICE_ACTIVITY_UPDATE = 'INVOICE_ACTIVITY_UPDATE';
export const INVOICE_ACTIVITY_SET_SEARCH_DROPDOWN = 'INVOICE_ACTIVITY_SET_SEARCH_DROPDOWN';
export const INVOICE_SET_COUNTS = 'INVOICE_SET_COUNTS';
export const INVOICE_SET_UPDATE_VARIABLE = 'INVOICE_SET_UPDATE_VARIABLE';
export const INVOICE_ACTIVITY_RESET_PAGINATION = 'INVOICE_ACTIVITY_RESET_PAGINATION';
export const INVOICE_ACTIVITY_SET_PAGINATION = 'INVOICE_ACTIVITY_SET_PAGINATION';
export const INVOICE_ACTIVITY_RESET_FILTERS = 'INVOICE_ACTIVITY_RESET_FILTERS';
export const INVOICE_ACTIVITY_SET_LOADING = 'INVOICE_ACTIVITY_SET_LOADING';
export const INVOICE_SET_BALANCE = 'INVOICE_SET_BALANCE';
export const INVOICE_RESET_AND_SET_PAGINATION = 'INVOICE_RESET_AND_SET_PAGINATION';
export const INVOICE_SAVE_LAST_REQUEST = 'INVOICE_SAVE_LAST_REQUEST';
export const INVOICE_SET_BID_CHARGES_LOADING = 'INVOICE_SET_BID_CHARGES_LOADING';
export const INVOICE_SET_BID_CHARGES = 'INVOICE_SET_BID_CHARGES';

// Teams
export const TEAMS_SET_LOADING = 'TEAMS_SET_LOADING';
export const TEAMS_SET_DATA = 'TEAMS_SET_DATA';
export const TEAMS_GET_ERROR = 'TEAMS_GET_ERROR';

// reference rates
export const EDIT_REFERENCE_RATES = 'EDIT_REFERENCE_RATES';
export const EDIT_REFERENCE_RATES_SUCCESS = 'EDIT_REFERENCE_RATES';
export const EDIT_REFERENCE_RATES_FAILED = 'EDIT_REFERENCE_RATES_FAILED';

// Shipment Tracking
export const SHIPMENT_TRACKING_ENABLE_LOADING = 'SHIPMENT_TRACKING_ENABLE_LOADING';
export const SHIPMENT_TRACKING_SET_DATA = 'SHIPMENT_TRACKING_SET_DATA';
export const SHIPMENT_TRACKING_ERROR = 'SHIPMENT_TRACKING_ERROR';
export const SHIPMENT_TRACKING_FILTERS = 'SHIPMENT_TRACKING_FILTERS';
export const SHIPMENT_TRACKING_SET_PAGINATION = 'SHIPMENT_TRACKING_SET_PAGINATION';
export const SHIPMENT_TRACKING_RESET_PAGINATION = 'SHIPMENT_TRACKING_RESET_PAGINATION';
export const SHIPMENT_TRACKING_RESET_FILTERS = 'SHIPMENT_TRACKING_RESET_FILTERS';
export const SHIPMENT_TRACKING_FETCHING_DATA = 'SHIPMENT_TRACKING_FETCHING_DATA';
export const SHIPMENT_TRACKING_CHECK_CHANGED = 'SHIPMENT_TRACKING_CHECK_CHANGED';
export const SHIPMENT_TRACKING_SET_POLLING_DATA = 'SHIPMENT_TRACKING_SET_POLLING_DATA';
export const SHIPMENT_TRACKING_SET_POLLING_REMAINING = 'SHIPMENT_TRACKING_SET_POLLING_REMAINING';
export const SHIPMENT_TRACKING_SET_PREV_PAGINATION = 'SHIPMENT_TRACKING_SET_PREV_PAGINATION';
export const SHIPMENT_TRACKING_BATCH_SIZE = 'SHIPMENT_TRACKING_BATCH_SIZE';
export const SHIPMENT_TRACKING_EXIM_TYPE = 'SHIPMENT_TRACKING_EXIM_TYPE';
export const SHIPMENT_TRACKING_SET_REMAINING = 'SHIPMENT_TRACKING_SET_REMAINING';
export const SHIPMENT_TRACKING_SUMMARY_METRIC_UPDATE = 'SHIPMENT_TRACKING_SUMMARY_METRIC_UPDATE';
export const SHIPMENT_TRACKING_DETAILS_LOADING = 'SHIPMENT_TRACKING_DETAILS_LOADING';
export const SHIPMENT_DETAILS_SET_DATA = 'SHIPMENT_DETAILS_SET_DATA';
export const SHIPMENT_DETAILS_ERROR = 'SHIPMENT_DETAILS_ERROR';
export const SHIPMENT_TRACKING_RESET_DETAIL_DATA = 'SHIPMENT_TRACKING_RESET_DETAIL_DATA';
export const SHIPMENT_TRACKING_SEARCH_FILTERS = 'SHIPMENT_TRACKING_SEARCH_FILTERS';
export const SET_MAP_LIST_VIEW = 'SET_MAP_LIST_VIEW';

//Carrier Advisory
export const ADVISORY_FETCH_ALL = 'ADVISORY_FETCH_ALL';

// Generic Filter-Pagination
export const PAGINATION_ACTIONS = (
  reducerLabel
): {
  ENABLE_LOADING: string;
  DISABLE_LOADING: string;
  SET_FILTER: string;
  APPLY_FILTER: string;
  RESET_FILTER: string;
  CANCEL_FILTER: string;
  SET_PAGINATION: string;
  RESET_PAGINATION: string;
  SET_PREV_PAGINATION: string;
  PAGINATION_LOADED: string;
  PAGINATION_ERROR: string;
} => {
  return {
    ENABLE_LOADING: `${reducerLabel}_PAGINATION_ENABLE_LOADING`,
    DISABLE_LOADING: `${reducerLabel}_PAGINATION_DISABLE_LOADING`,
    SET_FILTER: `${reducerLabel}_PAGINATION_SET_FILTER`,
    APPLY_FILTER: `${reducerLabel}_PAGINATION_APPLY_FILTER`,
    RESET_FILTER: `${reducerLabel}_PAGINATION_RESET_FILTER`,
    CANCEL_FILTER: `${reducerLabel}_PAGINATION_CANCEL_FILTER`,
    SET_PAGINATION: `${reducerLabel}_PAGINATION_PAGINATION`,
    RESET_PAGINATION: `${reducerLabel}_PAGINATION_RESET_PAGINATION`,
    SET_PREV_PAGINATION: `${reducerLabel}_PAGINATION_SET_PREV_PAGINATION`,
    PAGINATION_LOADED: `${reducerLabel}_PAGINATION_LOADED`,
    PAGINATION_ERROR: `${reducerLabel}_PAGINATION_ERROR`,
  };
};
// rate master
export const RATE_MASTER_FETCH_DATA = 'RATE_MASTER_FETCH_DATA';
export const RATE_MASTER_ENABLE_LOADING = 'RATE_MASTER_ENABLE_LOADING';
export const RATE_MASTER_FETCH_ERROR = 'RATE_MASTER_FETCH_ERROR';
export const RATE_MASTER_DISABLE_LOADING = 'RATE_MASTER_DISABLE_LOADING';
export const RATE_MASTER_SET_FILTERS = 'RATE_MASTER_SET_FILTERS';
export const RATE_MASTER_SET_PAGINATION = 'RATE_MASTER_SET_PAGINATION';
export const RATE_MASTER_RESET_FILTERS = 'RATE_MASTER_RESET_FILTERS';
export const RATE_MASTER_RESET_PAGINATION = 'RATE_MASTER_RESET_PAGINATION';
export const RATE_MASTER_SET_PREV_PAGINATION = 'RATE_MASTER_SET_PREV_PAGINATION';
export const RATE_MASTER_GET_MASTER = 'RATE_MASTER_GET_MASTER';

// bulk request
export const BULK_REQUEST_FETCH_DATA = 'BULK_REQUEST_FETCH_DATA';
export const BULK_REQUEST_ENABLE_LOADING = 'BULK_REQUEST_ENABLE_LOADING';
export const BULK_REQUEST_DISABLE_LOADING = 'BULK_REQUEST_DISABLE_LOADING';
export const BULK_REQUEST_FETCH_ERROR = 'BULK_REQUEST_FETCH_ERROR';
export const BULK_REQUEST_SET_FILTERS = 'BULK_REQUEST_SET_FILTERS';
export const BULK_REQUEST_SET_PAGINATION = 'BULK_REQUEST_SET_PAGINATION';
export const BULK_REQUEST_GET_RESET_FILTERS = 'BULK_REQUEST_GET_RESET_FILTERS';
export const BULK_REQUEST_RESET_PAGINATION = 'BULK_REQUEST_RESET_PAGINATION';
export const BULK_REQUEST_SET_PREV_PAGINATION = 'BULK_REQUEST_SET_PREV_PAGINATION';
export const BULK_POLL_REQUEST_SUCCESS = 'BULK_POLL_REQUEST_SUCCESS';
export const BULK_POLL_REQUEST_ERROR = 'BULK_POLL_REQUEST_ERROR';

// discover rates
export const DISCOVER_RATES_FETCH_DATA = 'DISCOVER_RATES_FETCH_DATA';
export const DISCOVER_RATES_ENABLE_LOADING = 'DISCOVER_RATES_ENABLE_LOADING';
export const DISCOVER_RATES_DISABLE_LOADING = 'DISCOVER_RATES_DISABLE_LOADING';
export const DISCOVER_RATES_FETCH_ERROR = 'DISCOVER_RATES_FETCH_ERROR';
export const DISCOVER_RATES_SET_SEARCH_FILTERS = 'DISCOVER_RATES_SET_SEARCH_FILTERS';
export const DISCOVER_RATES_SET_FILTERS = 'DISCOVER_RATES_SET_FILTERS';
export const DISCOVER_RATES_RESET_FILTERS = 'DISCOVER_RATES_RESET_FILTERS';
export const DISCOVER_RATES_SET_SORT_BY_FILTERS = 'DISCOVER_RATES_SET_SORT_BY_FILTERS';
export const DISCOVER_RATES_FETCH_FILTERS = 'DISCOVER_RATES_FETCH_FILTERS';
export const DISCOVER_RATES_ENABLE_FILTERS_LOADING = 'DISCOVER_RATES_ENABLE_FILTERS_LOADING';
export const DISCOVER_RATES_DISABLE_FILTERS_LOADING = 'DISCOVER_RATES_DISABLE_FILTERS_LOADING';
export const DISCOVER_RATES_SET_GRID_PORTS = 'DISCOVER_RATES_SET_GRID_PORTS';
export const DISCOVER_RATES_FETCH_GRID_DATA = 'DISCOVER_RATES_FETCH_GRID_DATA';
export const DISCOVER_RATES_SET_SEARCH_RESULTS = 'DISCOVER_RATES_SET_SEARCH_RESULTS';
export const DISCOVER_RATES_SET_GRID_FILTERS_RANGE = 'DISCOVER_RATES_SET_GRID_FILTERS_RANGE';
export const DISCOVER_RATES_SET_GRID_LOADING = 'DISCOVER_RATES_SET_GRID_LOADING';
export const DISCOVER_RATES_RESET_PORT_LIST = 'DISCOVER_RATES_RESET_PORT_LIST';
// DSR template actions
export const DSR_TEMPLATE_SAVE = 'DSR_TEMPLATE_SAVE';
export const DSR_TEMPLATE_RESET = 'DSR_TEMPLATE_RESET';
export const DSR_TEMPLATE_REMOVE = 'DSR_TEMPLATE_REMOVE';

// Markup
export const MARKUP_SET_FILTER = 'MARKUP_SET_FILTER';
export const MARKUP_RESET_FILTER = 'MARKUP_RESET_FILTER';
export const MARKUP_ENABLE_LOADING = 'MARKUP_ENABLE_LOADING';
export const MARKUP_DISABLE_LOADING = 'MARKUP_DISABLE_LOADING';
export const MARKUP_FETCH_DATA = 'MARKUP_FETCH_DATA';
export const MARKUP_FETCH_ERROR = 'MARKUP_FETCH_ERROR';


// Vessel Schedules
export const VESSELS_SET_SEARCH_PARAMS = 'VESSELS_SET_SEARCH_PARAMS';
export const VESSELS_ENABLE_LOADING = 'VESSELS_ENABLE_LOADING';
export const VESSELS_DISABLE_LOADING = 'VESSELS_DISABLE_LOADING';
export const VESSELS_FETCH_ERROR = 'VESSELS_FETCH_ERROR';
export const VESSELS_FETCH_DATA = 'VESSELS_FETCH_DATA';
export const VESSELS_RESET_FILTERS = 'VESSELS_RESET_FILTERS';
export const VESSELS_SET_FILTERS = 'VESSELS_SET_FILTERS';
export const VESSELS_FILTERED_DATA = 'VESSELS_FILTERED_DATA';
export const VESSELS_SET_SORT_BY = 'VESSELS_SET_SORT_BY';
export const VESSELS_SET_LANDING_PAGE = 'VESSELS_SET_LANDING_PAGE';

// Notifications
export const NOTIFICATIONS_SET_DATA = 'NOTIFICATIONS_SET_DATA';
export const NOTIFICATIONS_RESET_DATA = 'NOTIFICATIONS_RESET_DATA';
export const NOTIFICATIONS_SET_PAGINATION = 'NOTIFICATIONS_SET_PAGINATION';
export const NOTIFICATIONS_RESET_PAGINATION = 'NOTIFICATIONS_RESET_PAGINATION';
export const NOTIFICATIONS_SET_UNREAD_COUNT = 'NOTIFICATIONS_SET_UNREAD_COUNT';
export const NOTIFICATIONS_SET_ISLOADING = 'NOTIFICATIONS_SET_ISLOADING';
export const NOTIFICATIONS_SET_FILTERS = 'NOTIFICATIONS_SET_FILTERS';

//Air Cargo
export const AIR_CARGO_RESET_FILTER = 'AIR_CARGO_RESET_FILTER';
export const AIR_CARGO_APPLY_SORT = 'AIR_CARGO_APPLY_SORT';
export const AIR_CARGO_APPLY_FILTERS = 'AIR_CARGO_APPLY_FILTERS';
export const AIR_CARGO_SET_DATA = 'AIR_CARGO_SET_DATA';
export const AIR_CARGO_SET_SEARCH_RESULTS = 'AIR_CARGO_SET_SEARCH_RESULTS';
export const AIR_CARGO_SET_PAGINATION = 'AIR_CARGO_SET_PAGINATION';
export const AIR_CARGO_RESET_PAGINATION = 'AIR_CARGO_RESET_PAGINATION';
export const AIR_CARGO_SET_IS_COMPLETE = 'AIR_CARGO_SET_IS_COMPLETE';
export const AIR_CARGO_SET_IS_LOADING = 'AIR_CARGO_SET_IS_LOADING';
export const AIR_CARGO_SET_FILTER_TAGS = 'AIR_CARGO_SET_FILTER_TAGS';
export const AIR_CARGO_SET_STATUS = 'AIR_CARGO_SET_STATUS';
export const AIR_CARGO_SET_PAGES = 'AIR_CARGO_SET_PAGES';
export const AIR_CARGO_SET_TABID = 'AIR_CARGO_SET_TABID';
export const AIR_CARGO_SET_SELECTED_FILTERS = 'AIR_CARGO_SET_SELECTED_FILTERS';
export const AIR_CARGO_RESET_SELECTED_FILTERS = 'AIR_CARGO_RESET_SELECTED_FILTERS';
export const UPDATE_ONBOARDED_STATUS_IN_MASTER_DATA = 'UPDATE_ONBOARDED_STATUS_IN_MASTER_DATA';
export const AIR_CARGO_SET_DETAIL_VIEW_ID = 'AIR_CARGO_SET_DETAIL_VIEW_ID';
export const AIR_CARGO_REFRESH = 'AIR_CARGO_REFRESH';
export const RECENT_HAWB_FILTERS_LOADING = 'RECENT_HAWB_FILTERS_LOADING';
export const SET_RECENT_HAWB_FILTERS = 'SET_RECENT_HAWB_FILTERS';
// Persistent Iframe
export const IFRAME_SET_VISIBILITY = 'IFRAME_SET_VISIBILITY';
export const IFRAME_SET_DIMENSIONS = 'IFRAME_SET_DIMENSIONS';
export const IFRAME_SET_LOADED = 'IFRAME_SET_LOADED';
export const IFRAME_SET_RENDERED = 'IFRAME_SET_RENDERED';

// Payment
export const TOGGLE_PAYMENT_FLAG = 'TOGGLE_PAYMENT_FLAG';

// Landing Page
export const TOGGLE_SHOW_HOME_PAGE = 'TOGGLE_SHOW_HOME_PAGE';

// Dumurrage And Detention
export const DND_CONFIGURATION_SET_LOADING = 'DND_CONFIGURATION_SET_LOADING';
export const DND_CONFIGURATION_SET_DATA = 'DND_CONFIGURATION_SET_DATA';
export const DND_CONFIGURATION_SET_ERROR = 'DND_CONFIGURATION_SET_ERROR';
export const DND_CONFIGURATION_SET_PAGINATION = 'DND_CONFIGURATION_SET_PAGINATION';
export const DND_CONFIGURATION_RESET_PAGINATION = 'DND_CONFIGURATION_RESET_PAGINATION';
export const DND_CONFIGURATION_MAPPINGS_SET_DATA = 'DND_CONFIGURATION_MAPPINGS_SET_DATA';
export const DND_CONFIGURATION_MAPPINGS_SET_LOADING = 'DND_CONFIGURATION_MAPPINGS_SET_LOADING';

// Tasks Workflow
export const TASKS_WORKFLOW_SET_LOADING = 'TASKS_WORKFLOW_SET_LOADING';
export const TASKS_WORKFLOW_SET_ERROR = 'TASKS_WORKFLOW_SET_ERROR';
export const TASKS_WORKFLOW_MAPPINGS_SET_DATA = 'TASKS_WORKFLOW_MAPPINGS_SET_DATA';
export const TASK_WORKFLOW_MILESTONES_SET_DATA = 'TASK_WORKFLOW_MILESTONES_SET_DATA';
export const TASK_WORKFLOW_MILESTONES_SET_LOADING = 'TASK_WORKFLOW_MILESTONES_SET_LOADING';
export const TASK_WORKFLOW_MILESTONES_SET_ERROR = 'TASK_WORKFLOW_MILESTONES_SET_ERROR';
export const TASK_WORKFLOW_MILESTONES_DROPDOWN_SET_DATA = 'TASK_WORKFLOW_MILESTONES_DROPDOWN_SET_DATA';
export const TASK_WORKFLOW_MILESTONES_DROPDOWN_SET_LOADING = 'TASK_WORKFLOW_MILESTONES_DROPDOWN_SET_LOADING';
export const TASK_WORKFLOW_MILESTONES_DROPDOWN_SET_ERROR = 'TASK_WORKFLOW_MILESTONES_DROPDOWN_SET_ERROR';
export const TASK_WORKFLOW_PERMISSIONS_SET_DATA = 'TASK_WORKFLOW_PERMISSIONS_SET_DATA';
export const TASK_WORKFLOW_PERMISSIONS_SET_LOADING = 'TASK_WORKFLOW_PERMISSIONS_SET_LOADING';
export const TASK_WORKFLOW_PERMISSIONS_SET_ERROR = 'TASK_WORKFLOW_PERMISSIONS_SET_ERROR';
export const TASK_WORKFLOW_PERMISSIONS_UPDATE_DATA = 'TASK_WORKFLOW_PERMISSIONS_UPDATE_DATA';